import { render, staticRenderFns } from "./ProdutoToggle.vue?vue&type=template&id=0a520211&scoped=true&"
import script from "./ProdutoToggle.vue?vue&type=script&lang=js&"
export * from "./ProdutoToggle.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoToggle.vue?vue&type=style&index=0&id=0a520211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a520211",
  null
  
)

export default component.exports